import { FeziboShopifyShopItem } from '@/@types/shops';

export class CountryUtils {
  static countryMap: Record<string, string> = {};

  static urlMap: Record<string, string> = {};
  static shopList: FeziboShopifyShopItem[] = [];
  static shopMap: Record<string, FeziboShopifyShopItem> = {};

  static updateShopList(shops: FeziboShopifyShopItem[]) {
    this.shopList = shops;

    this.shopMap = this.shopList.reduce((res, cur) => ({ ...res, [cur.shopId]: cur }), {});
    this.urlMap = this.shopList.reduce((res, cur) => ({ ...res, [cur.shopId]: `https://${cur.shopDomain}` }), {});
    this.countryMap = this.shopList.reduce((res, cur) => ({ ...res, [cur.shopId]: cur.cnName }), {});
  }

  static getCountryText(value: string) {
    console.log('this.shopList:', this.shopList);
    return this.shopMap[value]?.cnName;
  }

  static getCurrency(value: string) {
    return this.shopMap[value]?.currencyCode;
  }

  static isValidCountryValue(val: string) {
    return !!this.shopMap[val];
  }

  static getShopBaseUrl(val: string) {
    return this.urlMap[val];
  }
  static getInventoryCountryCode(country: string) {
    return this.shopMap[country]?.countryCode;
  }
}

/* 对象对比操作START */
function _isBase(obj) {
  // 检测是否非null，undefined，object，array等影响typeof表现形式的类型
  return (
    obj != null &&
    typeof obj !== 'undefined' &&
    typeof obj !== 'object' &&
    !(Object.prototype.toString.call(obj) === '[object Function]')
  );
}

export function compare(objA, objB) {
  // 判断两个对象内容是否相等
  if (typeof objA === 'string' || typeof objB === 'string') {
    return objA === objB;
  }
  if (objA === objB) {
    return true;
  }
  if (_isBase(objA) && _isBase(objA)) {
    if (objA !== objB) {
      return false;
    }
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length === keysB.length) {
    for (let i = 0; i < keysA.length; i++) {
      const item = keysA[i];
      // eslint-disable-next-line @iceworks/best-practices/recommend-polyfill
      // eslint-disable-next-line no-prototype-builtins
      if (objB.hasOwnProperty(item)) {
        if (!compare(objA[item], objB[item])) {
          return false;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
  return true;
}

export function getProtocolHost() {
  const reg = /localhost|10\.|127.0.0.1/g;
  let { host } = window.location;
  if (reg.test(host)) {
    host = 'test.fezibo.youniverse.cc';
  }
  return `https://${host}`;
}

export const genRandomString = (length: number, lv: number = 0): string => {
  let text = '';
  let possible: string;
  switch (lv) {
    case 1:
      possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      break;
    case 2:
      possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      break;
    case 3:
      possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      break;
    case 4:
      possible = 'abcdefghijklmnopqrstuvwxyz';
      break;
    case 5:
      possible = '0123456789';
      break;
    default:
      possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789`-=[];,./~!@#$%^&*()_+{}:<>?';
      break;
  }

  for (let i = 0; i < length; i += 1) text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

export const createThrottle = <T extends (...args: any) => any>(func: T, duration: number) => {
  let timeout: NodeJS.Timeout | null = null;
  const newFunc = (...args: Parameters<T>) => {
    return new Promise<ReturnType<T>>((res) => {
      if (timeout !== null) {
        clearInterval(timeout);
        timeout = null;
      }
      timeout = setTimeout(() => {
        res(func.apply(null, args));
      }, duration);
    });
  };

  return newFunc;
};

export const createUniqueId = () => {
  return Math.random().toString(36).substr(2, 15);
};
